import { css, styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

import { BaseButton } from '../Button/Button.styles';

export const StyledBaseButton = styled(BaseButton)<{ $isOutlined?: boolean; $size: string; $variant: string }>`
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  ${({ $variant }) => {
    if ($variant === 'ghost') {
      return css`
        background: ${Colors.white};
        color: ${Colors.blue[100]};

        &:hover {
          background-color: ${Colors.blue[5]};
        }
        &:disabled {
          background-color: ${Colors.white};
          color: ${Colors.gray[20]};
        }
      `;
    }

    if ($variant === 'transparent') {
      return css`
        background: transparent;
        color: ${Colors.blue[100]};

        &:hover {
          color: ${Colors.darkBlue};
        }
        &:disabled {
          color: ${Colors.gray[20]};
        }
      `;
    }
  }}

  ${({ $isOutlined }) =>
    $isOutlined &&
    css`
      border: 1px solid ${Colors.blue[20]};
    `}

  svg {
    height: ${({ $size }) => ($size === 'large' ? '1.5rem' : '1rem')};
    width: ${({ $size }) => ($size === 'large' ? '1.5rem' : '1rem')};
  }
`;
